'use es6';

import { Record } from 'immutable';
import { MESSAGE_TYPE_ID, DATE_MESSAGE } from '../constants/messageTypes';
const DateMessage = Record({
  [MESSAGE_TYPE_ID]: DATE_MESSAGE,
  timestamp: null,
  id: null
}, 'DateMessage');
export default DateMessage;